import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semobold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "menu-item px-3" }
const _hoisted_4 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bold d-flex align-items-center fs-5" }
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-danger fw-bold fs-8 px-2 py-1 ms-2"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-light-info fw-bold fs-8 px-2 py-1 ms-2"
}
const _hoisted_9 = {
  key: 2,
  class: "badge badge-light-warning fw-bold fs-8 px-2 py-1 ms-2"
}
const _hoisted_10 = {
  key: 3,
  class: "badge badge-light-primary fw-bold fs-8 px-2 py-1 ms-2"
}
const _hoisted_11 = {
  key: 4,
  class: "badge badge-light-primary fw-bold fs-8 px-2 py-1 ms-2"
}
const _hoisted_12 = {
  href: "#",
  class: "fw-semobold text-muted text-hover-primary fs-7"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_15 = { class: "menu-item px-5" }
const _hoisted_16 = { class: "menu-item px-5" }
const _hoisted_17 = { class: "menu-item px-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_19 = {
  class: "menu-item px-5 d-none d-md-block",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_20 = { class: "menu-link px-5" }
const _hoisted_21 = { class: "menu-title position-relative" }
const _hoisted_22 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "symbol symbol-20px me-4" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  class: "menu-item px-5 d-block d-md-none",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_29 = { class: "menu-link px-5" }
const _hoisted_30 = { class: "menu-title position-relative" }
const _hoisted_31 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "symbol symbol-20px me-4" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 2,
  class: "menu-item px-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.userType !== 'anon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.user.prenom) + " " + _toDisplayString(_ctx.user.nom) + " ", 1),
                  (_ctx.user.userType === 'admin')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('navbar.userAccountMenu.userTypeBadge.admin')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.user.userType === 'staff')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('navbar.userAccountMenu.userTypeBadge.staff')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.user.userType === 'intervenant')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('navbar.userAccountMenu.userTypeBadge.teacher')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.user.userType === 'parent')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('navbar.userAccountMenu.userTypeBadge.parent')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.user.userType === 'student')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('navbar.userAccountMenu.userTypeBadge.student')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.user.mail), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.user.userType === 'admissible')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: { name: 'portal-home' },
              class: "menu-link px-5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('meta.titles.portal.home')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: { name: 'portal-search' },
              class: "menu-link px-5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('meta.titles.portal.search')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: { name: 'portal-cases' },
              class: "menu-link px-5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('meta.titles.portal.cases')), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("span", _hoisted_21, [
          _createTextVNode(_toDisplayString(_ctx.$t('navbar.userAccountMenu.languageMenu')) + " ", 1),
          _createElementVNode("span", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.currentLanguageLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: _ctx.currentLanguageLocale.flag,
              alt: "metronic"
            }, null, 8, _hoisted_23)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu-item px-3",
            key: i
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.setLang(i)),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(i) }])
            }, [
              _createElementVNode("span", _hoisted_26, [
                _createElementVNode("img", {
                  class: "rounded-1",
                  src: item.flag,
                  alt: "metronic"
                }, null, 8, _hoisted_27)
              ]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 10, _hoisted_25)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("span", _hoisted_30, [
          _createTextVNode(_toDisplayString(_ctx.$t('navbar.userAccountMenu.languageMenu')) + " ", 1),
          _createElementVNode("span", _hoisted_31, [
            _createTextVNode(_toDisplayString(_ctx.currentLanguageLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: _ctx.currentLanguageLocale.flag,
              alt: "metronic"
            }, null, 8, _hoisted_32)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu-item px-3",
            key: i
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.setLang(i)),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(i) }])
            }, [
              _createElementVNode("span", _hoisted_35, [
                _createElementVNode("img", {
                  class: "rounded-1",
                  src: item.flag,
                  alt: "metronic"
                }, null, 8, _hoisted_36)
              ]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 10, _hoisted_34)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.user.userType !== 'anon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
            class: "menu-link px-5"
          }, _toDisplayString(_ctx.$t('navbar.userAccountMenu.logoutBtn')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}